import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'money'})
export class Money implements PipeTransform {
  transform(value: string): string {
    let newStr: string = value.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
    return newStr;
  }
}